/**
 * react-data-table-component customStyles tuned for the new design system.
 *
 * Visual goals:
 *   - Calm light header (no orange gradient), uppercase ink-500 column titles
 *   - Subtle hover (brand-50 tint)
 *   - Compact rows by default, tabular numerals
 *   - Rounded outer container with shadow-xs and border ink-200
 */
export const tableStyles = {
  table: {
    style: {
      width: "100%",
      minWidth: "100%",
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      border: "1px solid #e2e8f0", // ink-200
      boxShadow: "0 1px 2px 0 rgb(16 24 40 / 0.04)", // shadow-xs
      overflow: "hidden",
    },
  },

  headRow: {
    style: {
      background: "#f8fafc", // ink-50
      minHeight: "36px",
      borderBottom: "1px solid #e2e8f0", // ink-200
      position: "sticky",
      top: 0,
      zIndex: 2,
    },
  },

  headCells: {
    style: {
      color: "#64748b", // ink-500
      fontWeight: 600,
      fontSize: "11px",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      padding: "0 16px",
      whiteSpace: "nowrap",
      fontFamily: "inherit",
    },
  },

  rows: {
    style: {
      minHeight: "38px",
      backgroundColor: "#ffffff",
      borderBottom: "1px solid #f1f5f9", // ink-100
      transition: "background 0.12s ease",
      color: "#0f172a", // ink-900
      fontVariantNumeric: "tabular-nums",
      "&:not(:last-of-type)": { borderBottom: "1px solid #f1f5f9" },
      "&:hover": {
        backgroundColor: "#f3f1fb", // brand-50
        cursor: "pointer",
      },
    },
    stripedStyle: {
      backgroundColor: "#fafbfd", // surface-subtle
    },
    selectedHighlightStyle: {
      backgroundColor: "#fff5f2", // accent-50
      borderLeft: "2px solid #ff683a",
    },
  },

  cells: {
    style: {
      fontSize: "14px",
      lineHeight: "20px",
      padding: "8px 14px", // py-2: dense audit rows, more records above the fold
      color: "#0f172a",
      fontFamily: "inherit",
    },
  },

  pagination: {
    style: {
      borderTop: "1px solid #f1f5f9",
      padding: "10px 16px",
      backgroundColor: "#ffffff",
      fontSize: "13px",
      color: "#475569",
      fontFamily: "inherit",
      borderRadius: "0 0 12px 12px",
    },
    pageButtonsStyle: {
      borderRadius: "6px",
      height: "32px",
      width: "32px",
      padding: 0,
      margin: "0 2px",
      cursor: "pointer",
      transition: "background-color 0.12s ease",
      color: "#334155",
      fill: "#334155",
      "&:disabled": { color: "#cbd5e1", fill: "#cbd5e1" },
      "&:hover:not(:disabled)": { backgroundColor: "#f1f5f9" },
      "&:focus": { outline: "none", backgroundColor: "#f1f5f9" },
    },
  },

  noData: {
    style: {
      padding: "48px 16px",
      backgroundColor: "#ffffff",
      color: "#64748b",
    },
  },

  progress: {
    style: {
      backgroundColor: "#ffffff",
      padding: "32px",
    },
  },
};
